import { RestaurantsList } from "./RestaurantsList";

export default RestaurantsList;
